"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isAlphaNumeric = function isAlphaNumeric(message) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    } // set regex for conditions


    var alphaNumeric = /^\w+$/; // test regex against field value

    var isMatch = alphaNumeric.test(field.value);
    return [isMatch, message || 'Field value must be letter(s) or number(s)'];
  };
};

var _default = isAlphaNumeric;
exports.default = _default;
//# sourceMappingURL=isAlphaNumeric.js.map